<template>
  <div class="maintenance-record-container">
    <!-- 顶部筛选栏 -->
    <el-header class="filter-header">
      <div class="filter-left">
        <el-select
          v-model="filterFenlei"
          placeholder="维护类型"
          clearable
          size="medium"
          style="width:160px;"
          @change="handleFilterChange"
        >
          <el-option label="全部" :value="null" />
          <el-option label="合同应收" :value="1" />
          <el-option label="合同已收" :value="2" />
          <el-option label="费用支出" :value="3" />
          <el-option label="合同发票" :value="4" />
        </el-select>
        <el-button type="primary" size="medium" @click="fetchRecords">查询</el-button>
      </div>
      <!-- <div class="filter-right">
        <span class="total-label">共 {{ totalItems }} 条记录</span>
      </div> -->
    </el-header>

    <!-- 主体：表格 + 分页 -->
    <el-main class="record-main">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <i class="el-icon-loading" /> 加载中...
      </div>

      <!-- 空状态 -->
      <div v-else-if="!recordList || recordList.length === 0" class="empty-state">
        <i class="el-icon-document" />
        <p>暂无维护记录</p>
      </div>

      <!-- 表格 -->
      <template v-else>
        <el-table
          :data="recordList"
          border
          stripe
          height="68vh"
          style="width:100%;"
        >
          <el-table-column prop="id" label="记录ID" width="80" align="center" />
          <el-table-column prop="ht_code" label="合同编号" min-width="160" show-overflow-tooltip />
          <el-table-column label="维护类型" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getFenleiTagType(scope.row.fenlei)" size="small">
                {{ getFenleiText(scope.row.fenlei) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="comlist_v1" label="内容/项目" min-width="140" show-overflow-tooltip />
          <el-table-column prop="comlist_v2" label="方式/编号" min-width="120" show-overflow-tooltip />
          <el-table-column prop="comlist_f1" label="金额" width="120" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.comlist_f1 || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column prop="comlist_d1" label="日期" width="140" align="center" />
          <el-table-column prop="comlist_v3" label="账户/公司" min-width="140" show-overflow-tooltip />
          <el-table-column prop="comlist_v5" label="备注" min-width="120" show-overflow-tooltip />
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="showDetail(scope.row)"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        />
      </template>
    </el-main>

    <!-- 详情弹窗 -->
    <el-dialog
      title="维护记录详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @closed="detailData = {}"
    >
      <div v-if="detailData && detailData.id">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="记录ID">{{ detailData.id }}</el-descriptions-item>
          <el-descriptions-item label="合同编号">{{ detailData.ht_code }}</el-descriptions-item>
          <el-descriptions-item label="维护类型">
            <el-tag :type="getFenleiTagType(detailData.fenlei)">
              {{ getFenleiText(detailData.fenlei) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="内容">{{ detailData.comlist_v1 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="方式/编号">{{ detailData.comlist_v2 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="账户/公司">{{ detailData.comlist_v3 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="经办人/分类">{{ detailData.comlist_v4 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="金额">¥{{ detailData.comlist_f1 || '0.00' }}</el-descriptions-item>
          <el-descriptions-item label="日期">{{ detailData.comlist_d1 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ detailData.comlist_v5 || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'MaintenanceRecordList',
  data () {
    return {
      loading: false,
      recordList: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 0,

      // 筛选条件
      filterFenlei: null, // null 表示全部

      // 详情
      detailDialogVisible: false,
      detailData: {}
    }
  },
  mounted () {
    this.fetchRecords()
  },
  methods: {
    // 获取品牌ID（从 localStorage 读取）
    getBrandId () {
      return parseInt(localStorage.getItem('sh_id')) || 0
    },

    // 获取维护记录列表
    async fetchRecords () {
      this.loading = true
      try {
        const params = {
          a: 'weilist',
          brand_id: this.getBrandId(),
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterFenlei !== null && this.filterFenlei !== '') {
          params.fenlei = this.filterFenlei
        }

        const res = await request.post('/ht/ht_lists.php', params)
        if (res && res.code === '0') {
          this.recordList = res.data || []
          if (res.pages) {
            this.totalPages = parseInt(res.pages)
            this.totalItems = this.totalPages * this.pageSize
          } else {
            this.totalItems = this.recordList.length
          }
        } else {
          this.$message.error(res.msg || '获取记录失败')
          this.recordList = []
          this.totalItems = 0
          this.totalPages = 0
        }
      } catch (e) {
        console.error('获取维护记录失败', e)
        this.$message.error('网络异常')
      } finally {
        this.loading = false
      }
    },

    // 筛选变化
    handleFilterChange () {
      this.currentPage = 1
      this.fetchRecords()
    },

    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchRecords()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchRecords()
    },

    // 维护类型映射（统一使用字符串键）
    getFenleiText (fenlei) {
      const map = {
        1: '合同应收',
        2: '合同已收',
        3: '费用支出',
        4: '合同发票'
      }
      return map[String(fenlei)] || '未知'
    },
    getFenleiTagType (fenlei) {
      const map = {
        1: 'primary',
        2: 'success',
        3: 'warning',
        4: 'info'
      }
      return map[String(fenlei)] || ''
    },

    // 查看详情
    showDetail (row) {
      this.detailData = { ...row }
      this.detailDialogVisible = true
    }
  }
}
</script>

<style scoped>
.maintenance-record-container {
  padding: 0 20px;
  box-sizing: border-box;
  height: 85vh;
  overflow: auto;
  background-color: #f0f2f5;
  border-radius: 12px;
  min-height: 100vh;
}

.filter-header {
  background-color: #ffffff;
  border-bottom: 1px solid #e8ecf1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.filter-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-right .total-label {
  color: #909399;
  font-size: 14px;
}

.record-main {
  flex: 1;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.loading-container,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  background: #fafbfc;
  border-radius: 8px;
}

.loading-container .el-icon-loading {
  font-size: 40px;
  color: #409eff;
  margin-bottom: 12px;
}

.empty-state i {
  font-size: 56px;
  color: #c0c4cc;
  margin-bottom: 12px;
}

.pagination {
  flex-shrink: 0;
  text-align: right;
  background: #ffffff;
  padding: 12px 16px;
  border-radius: 8px;
}
</style>
